/**
 * Continuous load for /collections directory and all-brands vendor grids.
 * Fetches only the listing section (?section_id=) and appends matching cards.
 * Never parse a full HTML document — that is what Chrome kills
 * (RESULT_CODE_KILLED_BAD_MESSAGE). Re-applies vendor title filters client-side
 * so later pages stay filtered.
 */
(function () {
  if (window.__dwCollectionCardsInfiniteInit) return;
  window.__dwCollectionCardsInfiniteInit = true;

  var SEL_WRAP = '.dw-collection-cards-infinite';
  var SEL_GRID = '.dw-collection-cards-grid[data-dw-infinite-grid]';
  var SEL_NEXT = '.dw-collection-cards-infinite__next';
  var SEL_STATUS = '.dw-collection-cards-infinite__status';
  var SEL_SENTINEL = '.dw-collection-cards-infinite__sentinel';
  var MAX_FRAGMENT_CHARS = 800000;

  function findGrid(wrap) {
    if (!wrap) return null;
    var root = wrap.parentElement;
    if (!root) return null;
    var grids = root.querySelectorAll(SEL_GRID);
    if (!grids.length) return null;
    var source = wrap.getAttribute('data-dw-grid-source') || '';
    for (var i = 0; i < grids.length; i++) {
      if ((grids[i].getAttribute('data-dw-grid-source') || '') === source) {
        return grids[i];
      }
    }
    return grids[grids.length - 1];
  }

  function parseVendors(wrap) {
    var raw = wrap.getAttribute('data-dw-vendors') || '[]';
    try {
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      return list
        .map(function (v) {
          return String(v || '')
            .trim()
            .toLowerCase();
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function cardTitle(node) {
    if (!node || node.nodeType !== 1) return '';
    var fromAttr = node.getAttribute('data-collection-title');
    if (fromAttr) return fromAttr.trim().toLowerCase();
    var titleEl = node.querySelector('.dw-brand-hub-card__title');
    return titleEl ? titleEl.textContent.trim().toLowerCase() : '';
  }

  function titleMatchesVendor(title, vendors, matchMode) {
    if (!title || !vendors.length) return false;
    var mode = matchMode || 'contains';
    for (var i = 0; i < vendors.length; i++) {
      var v = vendors[i];
      if (!v) continue;
      if (mode === 'exact') {
        if (title === v) return true;
        if (title.length > v.length && title.slice(0, v.length) === v) {
          var nextCh = title.charAt(v.length);
          if (nextCh === ' ' || nextCh === '') return true;
        }
      } else if (title.indexOf(v) !== -1) {
        return true;
      }
    }
    return false;
  }

  function isDiscontinuedTitle(title) {
    return !!(title && title.indexOf('discontinued') !== -1);
  }

  /** Longest matching shop vendor for a collection title (same rules as Liquid). */
  function resolveVendorKey(title, vendors, matchMode) {
    if (!title || !vendors.length) return '';
    var sorted = vendors.slice().sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < sorted.length; i++) {
      if (titleMatchesVendor(title, [sorted[i]], matchMode)) return sorted[i];
    }
    return '';
  }

  function cardProductCount(node) {
    if (!node || node.nodeType !== 1) return 0;
    var raw = node.getAttribute('data-dw-product-count');
    var n = parseInt(raw, 10);
    return isNaN(n) ? 0 : n;
  }

  function dedupeGroupKey(node, vendors, matchMode, extrasPipe) {
    if (handleInExtras(node, extrasPipe)) {
      var extraHandle = (node.getAttribute('data-collection-handle') || '').trim().toLowerCase();
      if (extraHandle) return 'extra:' + extraHandle;
    }
    var fromAttr = (node.getAttribute('data-dw-vendor-key') || '').trim().toLowerCase();
    if (fromAttr) return fromAttr;
    var title = cardTitle(node);
    var key = resolveVendorKey(title, vendors, matchMode);
    if (key) return key;
    var handleOnly = (node.getAttribute('data-collection-handle') || '').trim().toLowerCase();
    return handleOnly ? 'handle:' + handleOnly : '';
  }

  /** One brand card per vendor — keep the collection with the most products. */
  function dedupeVendorBrandGrid(grid, vendors, matchMode, extrasPipe) {
    if (!grid || grid.getAttribute('data-dw-vendor-dedupe') !== '1') return;
    var cards = Array.prototype.slice.call(
      grid.querySelectorAll('.dw-brand-hub-card[data-collection-handle]')
    );
    var winners = {};
    for (var i = 0; i < cards.length; i++) {
      var node = cards[i];
      var title = cardTitle(node);
      if (isDiscontinuedTitle(title)) {
        node.remove();
        continue;
      }
      var groupKey = dedupeGroupKey(node, vendors, matchMode, extrasPipe);
      if (!groupKey) continue;
      var count = cardProductCount(node);
      var prev = winners[groupKey];
      if (!prev || count > prev.count) {
        if (prev && prev.node.parentNode) prev.node.remove();
        winners[groupKey] = { node: node, count: count };
      } else if (prev) {
        node.remove();
      }
    }
  }

  function dedupeFromGrid(grid) {
    if (!grid) return;
    var root = grid.parentElement;
    if (!root) return;
    var wrap = root.querySelector(SEL_WRAP);
    if (!wrap) return;
    dedupeVendorBrandGrid(
      grid,
      parseVendors(wrap),
      wrap.getAttribute('data-dw-vendor-match') || 'contains',
      wrap.getAttribute('data-dw-vendor-extras') || '|'
    );
  }

  function handleInExtras(node, extrasPipe) {
    if (!extrasPipe || extrasPipe === '|') return false;
    var handle = (node.getAttribute('data-collection-handle') || '').trim().toLowerCase();
    if (!handle) return false;
    return extrasPipe.indexOf('|' + handle + '|') !== -1;
  }

  function shouldKeepCard(node, filterMode, vendors, matchMode, extrasPipe) {
    if (!filterMode) return true;
    var title = cardTitle(node);
    if (isDiscontinuedTitle(title)) return false;
    if (filterMode === 'include' && handleInExtras(node, extrasPipe)) return true;
    if (!vendors.length) return filterMode !== 'include';
    var matched = resolveVendorKey(title, vendors, matchMode) !== '';
    if (filterMode === 'exclude') return !matched;
    if (filterMode === 'include') return matched;
    return true;
  }

  function setStatus(wrap, text) {
    var status = wrap.querySelector(SEL_STATUS);
    if (status) status.textContent = text || '';
  }

  function sectionFetchUrl(href, wrap) {
    var url = new URL(href, window.location.origin);
    var sid = wrap && wrap.getAttribute('data-dw-section-id');
    if (!sid) throw new Error('missing section id');
    url.searchParams.set('section_id', sid);
    url.searchParams.delete('view');
    return url.toString();
  }

  function htmlIsUnsafeFragment(html) {
    if (!html) return true;
    if (html.length > MAX_FRAGMENT_CHARS) return true;
    if (/Result code:\s*killed/i.test(html)) return true;
    var head = html.slice(0, 256).toLowerCase();
    return head.indexOf('<!doctype') !== -1 || /<html[\s>]/i.test(head);
  }

  function done(wrap) {
    wrap.setAttribute('data-dw-infinite-done', '1');
    var obs = wrap.__dwInfiniteObs;
    if (obs) {
      obs.disconnect();
      wrap.__dwInfiniteObs = null;
    }
    var next = wrap.querySelector(SEL_NEXT);
    if (next) next.remove();
    var sentinel = wrap.querySelector(SEL_SENTINEL);
    if (sentinel) sentinel.remove();
    setStatus(wrap, '');
    wrap.hidden = true;
  }

  function loadNext(wrap) {
    if (!wrap || wrap.getAttribute('data-dw-infinite-loading') === '1') return;
    if (wrap.getAttribute('data-dw-infinite-done') === '1') return;

    var next = wrap.querySelector(SEL_NEXT);
    var href = next && next.getAttribute('href');
    if (!href) {
      done(wrap);
      return;
    }

    wrap.setAttribute('data-dw-infinite-loading', '1');
    setStatus(wrap, wrap.getAttribute('data-dw-loading-label') || 'Loading…');

    var filterMode = wrap.getAttribute('data-dw-vendor-filter') || '';
    var vendors = parseVendors(wrap);
    var matchMode = wrap.getAttribute('data-dw-vendor-match') || 'contains';
    var extrasPipe = wrap.getAttribute('data-dw-vendor-extras') || '|';

    fetch(sectionFetchUrl(href, wrap), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (htmlIsUnsafeFragment(html)) throw new Error('unsafe fragment');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = wrap.getAttribute('data-dw-grid-source') || '';
        var remoteGrid = null;
        var remoteGrids = doc.querySelectorAll(SEL_GRID);
        for (var i = 0; i < remoteGrids.length; i++) {
          if ((remoteGrids[i].getAttribute('data-dw-grid-source') || '') === source) {
            remoteGrid = remoteGrids[i];
            break;
          }
        }
        if (!remoteGrid && remoteGrids.length) remoteGrid = remoteGrids[remoteGrids.length - 1];

        var added = 0;
        var grid = findGrid(wrap);
        if (grid && remoteGrid) {
          var nodes = Array.prototype.slice.call(remoteGrid.children);
          for (var n = 0; n < nodes.length; n++) {
            var node = nodes[n];
            if (!shouldKeepCard(node, filterMode, vendors, matchMode, extrasPipe)) continue;
            grid.appendChild(node);
            added += 1;
          }
          dedupeFromGrid(grid);
        }

        var remoteWrap = null;
        var remoteWraps = doc.querySelectorAll(SEL_WRAP);
        for (var j = 0; j < remoteWraps.length; j++) {
          if ((remoteWraps[j].getAttribute('data-dw-grid-source') || '') === source) {
            remoteWrap = remoteWraps[j];
            break;
          }
        }
        var remoteNext = remoteWrap && remoteWrap.querySelector(SEL_NEXT);
        var nextHref = remoteNext && remoteNext.getAttribute('href');
        if (nextHref && next) {
          next.setAttribute('href', nextHref);
          wrap.removeAttribute('data-dw-infinite-loading');
          setStatus(wrap, '');
          // Keep scanning when this page had no matching cards (vendor filters).
          if (added === 0) {
            loadNext(wrap);
          }
        } else {
          done(wrap);
          var gridDone = findGrid(wrap);
          dedupeFromGrid(gridDone);
        }
      })
      .catch(function () {
        wrap.removeAttribute('data-dw-infinite-loading');
        setStatus(wrap, wrap.getAttribute('data-dw-error-label') || 'Could not load more. Try again.');
        if (next) next.hidden = false;
      });
  }

  function bindWrap(wrap) {
    if (!wrap || wrap.getAttribute('data-dw-infinite-bound') === '1') return;
    wrap.setAttribute('data-dw-infinite-bound', '1');

    var next = wrap.querySelector(SEL_NEXT);
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        next.hidden = true;
        loadNext(wrap);
      });
    }

    var sentinel = wrap.querySelector(SEL_SENTINEL);
    if (sentinel && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext(wrap);
          });
        },
        { rootMargin: '240px 0px' }
      );
      wrap.__dwInfiniteObs = obs;
      obs.observe(sentinel);
    } else if (next) {
      next.hidden = false;
    }
  }

  function init() {
    document.querySelectorAll(SEL_WRAP).forEach(bindWrap);
    document.querySelectorAll(SEL_GRID + '[data-dw-vendor-dedupe="1"]').forEach(dedupeFromGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
